import { render, staticRenderFns } from "./LydiaxFailed.vue?vue&type=template&id=adcff436&"
import script from "./LydiaxFailed.vue?vue&type=script&lang=js&"
export * from "./LydiaxFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports